import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';

import { WidgetModule } from '../main/widgets/widget.module';
import { WidgetService } from '../main/widgets/widget.service';
import { LayoutBuilderComponent } from './layout-builder/layout-builder.component';
import { TagInputComponent } from './tag-input/tag-input.component';
import { WidgetsToolbarComponent } from './widgets-toolbar/widgets-toolbar.component';
import { ThemeEmitterModule } from './theme-emitter/theme-emitter.module';
import { ValidationErrorsModule } from './validation-errors/validation-errors.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { CheckListComponentModule } from './check-list/check-list.module';
import { IntecDatePickerModule } from './intec-date-picker2/intec-date-picker.module';
import { DevExtremeModule } from 'devextreme-angular';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { DataGridModule } from './data-grid/data-grid.module';
import { ListModule } from './list/list.module';
import { TranslationControlsComponentModule } from './translation-controls/translation-controls.module';
import { VisualizeComponent } from './visualize/visualize.component';
import { SubjectVisualizerDialogComponent } from './subject-visualizer-dialog/subject-visualizer-dialog.component';
import { MapComponent } from './map/map.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ShowMapComponent } from './show-map/show-map.component';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';

@NgModule({
    declarations: [
        LayoutBuilderComponent,
        WidgetsToolbarComponent,
        TagInputComponent,
        VisualizeComponent,
        SubjectVisualizerDialogComponent,
        MapComponent,
        ShowMapComponent,
    ],
    imports: [
        CommonModule,
        MatDividerModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatInputModule,
        MatAutocompleteModule,
        MatChipsModule,
        WidgetModule,
        GridsterModule,
        DynamicModule,
        FuseSharedModule,
        DataGridModule,
        MatDatepickerModule,
        MatTooltipModule,
        ThemeEmitterModule,
        ListModule,
        ValidationErrorsModule,
        PhoenixDirectivesModule,
        IntecDatePickerModule,
        CheckListComponentModule,
        DevExtremeModule,        
        PhoenixPipesModule.forRoot(),
        TranslationControlsComponentModule,
        LeafletModule,
        LeafletMarkerClusterModule,
    ],
    exports: [
        DataGridModule,
        WidgetsToolbarComponent,
        LayoutBuilderComponent,
        TagInputComponent,
        ListModule,
        ThemeEmitterModule,
        ValidationErrorsModule,
        IntecDatePickerModule,
        CheckListComponentModule,        
        TranslationControlsComponentModule,
        VisualizeComponent,
        MapComponent,
        ShowMapComponent,
    ],
    providers: [
        WidgetService,
    ]
})
export class ComponentsModule {
}
